import { SVGProps } from 'react'

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={12}
    viewBox="0 0 14 12"
    {...props}
  >
    <path d="M3.5 6A3.5 3.5 0 0 1 7 9.5v2a.5.5 0 0 1-1 0v-2a2.5 2.5 0 0 0-5 0v2a.5.5 0 0 1-1 0v-2A3.5 3.5 0 0 1 3.5 6Zm7 0A3.5 3.5 0 0 1 14 9.5v2a.5.5 0 0 1-1 0v-2a2.5 2.5 0 0 0-5 0c0-.686-.153-1.335-.428-1.917A3.496 3.496 0 0 1 10.5 6Zm-7-6a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm7 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-7 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" />
  </svg>
)
export default SvgComponent
